import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid } from '@mui/material';
import classNames from 'classnames';
import { OATypography } from '../../../components/widgets';
import { theme } from '../../../config/theme';
import { useState } from 'react';
import { ArrowDownSVG } from '../../../components/Icons';
import { getFormattedDate } from '../../../helper';

export const FareRules = ({ data, roomInfo }: any) => {
  const [accordionStates, setAccordionStates] = useState({
    cancellationExpanded: true
  });
  
  return (
    <div className='order-view--activity card pb-6'>
      <Box display='flex' justifyContent='space-between' alignItems='center' padding='16px'>
        <h3 className='card-title fw-bolder text-dark ps-4'>Fare Rules</h3>
      </Box>

      <Divider />
        <Box>
          {roomInfo?.map((room: any, index: number) => (
            <Accordion
            expanded={accordionStates.cancellationExpanded}
            onChange={() =>
              setAccordionStates((prev) => ({
                ...prev,
                cancellationExpanded: !prev.cancellationExpanded
              }))
            }
            sx={{ boxShadow: 'none', borderRadius: '6px', marginBottom: '16px' }}
          >
            <AccordionSummary expandIcon={<ArrowDownSVG down={true} fill='#011229' />} sx={{ padding: '0 16px' }}>
              <OATypography variant='h4' sx={{ fontWeight: 500 }}>
                {room?.displayName}
              </OATypography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Box sx={{ border: '1px #EFF2F5 solid', boxSizing: 'border-box' }}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' padding='10px'>
                      <OATypography
                        variant='subtitle2'
                        sx={{ color: theme.palette.grey[400], fontSize: '12px', lineHeight: '16px' }}
                      >
                        CANCEL BETWEEN
                      </OATypography>
                      <OATypography
                        variant='subtitle2'
                        sx={{ color: theme.palette.grey[400], fontSize: '12px', lineHeight: '16px' }}
                      >
                        CHARGES (ROOM)
                      </OATypography>
                    </Box>
                    <Divider />
                    {room?.cancellationPolicy?.map((obj: any, index: number) => (
                      <>
                        <Box
                          display='flex'
                          justifyContent='space-between'
                          alignItems='center'
                          padding='10px'>
                          <OATypography variant='body2'>
                            {`${getFormattedDate(obj?.startDate, 'DD MMM, HH:mm')} - ${getFormattedDate(
                              obj?.endDate,
                              'DD MMM, HH:mm'
                            )}`}
                          </OATypography>
                          <OATypography variant='body2'>{obj?.charges}</OATypography>
                        </Box>
                        {index !== room?.cancellationPolicy?.length - 1 && <Divider />}
                      </>
                    ))}
                    <Divider />
                  </Box>
                </Grid>
              </Grid>
            </AccordionDetails>
            </Accordion>
          ))}
          <Divider />
          <Box padding='24px'>
            <OATypography variant='h4' sx={{ fontWeight: 500, marginTop: '36px' }}>
              Terms & conditions
            </OATypography>
            <OATypography variant='body1' sx={{ marginTop: '16px', lineHeight: '17px' }}>
              Booking Terms & Conditions
            </OATypography>
            <ul
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '22px',
                marginTop: '4px',
                color: '#616876'
              }}>
              <li>Guests must present a valid photo ID upon check-in. The hotel may request a credit card or cash deposit to cover additional services.</li>
              <li>
                Any extra expenses such as parking fees, phone calls, room service, city taxes, etc., are the responsibility of the guest and should be settled directly with the hotel before departure.
              </li>
              <li>
                If the residency or nationality information provided at booking is incorrect, supplementary charges may apply, payable directly to the hotel at check-in or check-out.
              </li>
              <li>
                Requests for bed type, early check-in, late check-out, or smoking rooms are subject to availability at check-in and are not guaranteed.
              </li>
              <li>
              Full cancellation charges apply for early check-out unless otherwise specified.
              </li>
              <li>
                Minimum age for guest to check-in is 18 years.
              </li>
            </ul>
            <OATypography variant='body1' sx={{ marginTop: '16px', lineHeight: '17px' }}>
              Hotel Policies
            </OATypography>
            <ul
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '22px',
                marginTop: '4px',
                color: '#616876'
              }}>
              <li>Check-in and check-out times are determined by the hotel and may vary based on their standard policies. Please confirm specific timings with the hotel directly.</li>
            </ul>
            <OATypography variant='body1' sx={{ marginTop: '16px', lineHeight: '17px' }}>
              Check-In Instructions:
            </OATypography>
            <ul
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '22px',
                marginTop: '4px',
                color: '#616876'
              }}>
              <li>Extra-person charges may apply depending on hotel policy.</li>
              <li>Government-issued ID and a credit/debit card or cash deposit are required for incidental charges.</li>
              <li>Special requests are subject to availability and may incur additional fees.</li>
              <li>The name on the credit card used for incidentals must match the reservation name.</li>
              <li>Accepted payment methods include credit cards, debit cards, and mobile payments. Cash payments are not accepted.</li>
              <li>The property reserves the right to pre-authorize the guest’s credit card before arrival.</li>
            </ul>
            <OATypography variant='body1' sx={{ marginTop: '16px', lineHeight: '17px' }}>
            Cancellation Policy:
            </OATypography>
            <ul
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '22px',
                marginTop: '4px',
                color: '#616876'
              }}>
              <li>Cancelled and rebooked reservations will not be accepted.</li>
            </ul>
          </Box>
        </Box>
    </div>
  );
};
